import React from "react";

interface IHyperLinkProps {
	href: string;
	label: string;
	onClick?: () => void;
	target?: string;
	disabled?: boolean; // Add the disabled prop
}

const HyperLink: React.FC<IHyperLinkProps> = ({
	href,
	label,
	target,
	onClick,
	disabled = false, // Default to false if not provided
}) => {
	return (
		<a
			target={disabled ? undefined : target} // Disable target when disabled
			href={disabled ? undefined : href} // Prevent navigation when disabled
			onClick={(e) => {
				if (disabled) {
					e.preventDefault(); // Prevent default click behavior
				} else if (onClick) {
					onClick(); // Call onClick only if not disabled
				}
			}}
			aria-disabled={disabled} // Accessibility support
			className={`font-Poppins font-semibold ${
				disabled
					? "text-gray-400 cursor-not-allowed" // Disabled styles
					: "text-blue-600 dark:text-blue-500 hover:text-orange-500 hover:underline"
			}`}
		>
			{label}
		</a>
	);
};

export default HyperLink;
